import { z } from 'zod/v4';

import { WritableQuoteBuilderStateType } from '../../types/state';
import { buildElementId } from '../utilities/element-id';
import { buildIssueId } from '../utilities/issue-id';
import { deleteIssue, upsertIssue } from '../utilities/issue-managers';

type ValidateLeadTimeParams = {
  leadTime: string;
  quoteLineUuid: string;
};

export const leadTimeValidator = z.coerce
  .number({
    error: 'Lead time is required',
  })
  .int('Lead time must be an integer')
  .gt(0, 'Lead time must be greater than 0');

export function validateLeadTime(
  state: WritableQuoteBuilderStateType,
  { leadTime, quoteLineUuid }: ValidateLeadTimeParams,
) {
  const invalidIssueId = buildIssueId({
    area: 'quoteLine',
    field: 'leadTime',
    quoteLineUuid,
    type: 'invalid',
  });

  const result = leadTimeValidator.safeParse(leadTime);

  if (!result.success) {
    const error = z.flattenError(result.error).formErrors[0];

    upsertIssue(state, invalidIssueId, {
      action: {
        elementId: buildElementId({
          field: 'leadTime',
          uuid: quoteLineUuid,
        }),
        type: 'modify',
      },
      area: 'quoteLine',
      description: error,
      field: 'leadTime',
      quoteLineUuid,
      severity: 'error',
      title: 'Invalid lead time',
      type: 'invalid',
    });

    return;
  }

  deleteIssue(state, invalidIssueId);

  return result.data;
}
